import React from 'react'

import { 
    Dropdown,
    Menu,
} from 'antd'

import { 
    MenuOutlined,
} from '@ant-design/icons'
import {Link} from 'gatsby'

const MenuResponsive = ({english}) => { 
    const menu = (
        <Menu>
            <Menu.Item key="plan-maestro">
                <Link 
                    href={english? '/en#plan-maestro' : '/#plan-maestro'}
                >{english? 'Master plan' : 'Plan maestro'}</Link> 
            </Menu.Item>
            <Menu.Item key="proyectos">
                <Link
                    href={english? '/en#proyectos' : '/#proyectos'}
                >{english? 'Projects' : 'Proyectos'}</Link> 
            </Menu.Item>
            <Menu.Item key="ubicacion">
                <Link 
                    href={english? '/en#ubicacion' : '/#ubicacion'}
                >{english? 'Location' : 'Ubicación'}</Link>
            </Menu.Item>
            <Menu.Item key="contacto">
                <Link 
                    href={english ? '/en#contacto' : '/#contacto'}
                >{english? 'Contact' : 'Contacto'}</Link> 
            </Menu.Item>
        </Menu>
    );

    return (
        <div className="menu-responsive">
            <Dropdown overlay={menu}>
                <a 
                    className="ant-dropdown-link"
                    onClick={e => e.preventDefault()}
                >
                    <MenuOutlined />
                </a>
            </Dropdown>
        </div>
    )
}

export default MenuResponsive